import { Platform, StyleSheet } from 'react-native';
import { colors, spacing, ticketColors, ticketFonts, typography } from '../theme/public-api';

/** Panel denso operativo: borde lateral ámbar + superficie (Customer, maestros, ventas). */
export const operationalFilterStyles = StyleSheet.create({
  panel: {
    alignSelf: 'stretch',
    width: '100%',
    marginBottom: spacing.sm,
  },
  cardWrap: {
    flexDirection: 'row',
    borderRadius: 14,
    overflow: 'hidden',
    backgroundColor: colors.surface,
    borderWidth: 1,
    borderColor: colors.borderSoft,
  },
  cardAccent: {
    width: 3,
    backgroundColor: ticketColors.gold,
    opacity: 0.55,
  },
  cardBody: {
    flex: 1,
    minWidth: 0,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    gap: spacing.sm,
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },
  titleCol: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  title: {
    ...typography.title3,
    color: colors.textPrimary,
    fontWeight: '700',
  },
  hint: {
    ...typography.caption,
    color: colors.textMuted,
    lineHeight: 17,
  },
  hintCompact: {
    ...typography.caption,
    color: colors.textMuted,
    fontSize: 12,
    lineHeight: 16,
    marginTop: -2,
  },
  headerActionBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    minHeight: 36,
    paddingHorizontal: spacing.sm,
    borderRadius: 10,
    backgroundColor: ticketColors.gold,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    flexShrink: 0,
  },
  headerActionBtnIconOnly: {
    width: 40,
    height: 40,
    paddingHorizontal: 0,
  },
  headerActionBtnText: {
    ...typography.caption,
    color: ticketColors.goldInk,
    fontWeight: '800',
    fontFamily: ticketFonts.sans,
  },
  searchWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    minHeight: 40,
    paddingHorizontal: spacing.sm,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: colors.controlBorder,
    backgroundColor: colors.inputBackground,
  },
  searchWrapDesk: {
    height: 40,
    minHeight: 40,
    paddingVertical: 0,
    paddingHorizontal: 12,
    backgroundColor: ticketColors.paper,
    borderColor: ticketColors.ruleSoft,
  },
  searchWrapDeskDense: {
    height: 44,
    minHeight: 44,
  },
  searchIcon: {
    marginRight: 2,
  },
  searchInput: {
    flex: 1,
    minWidth: 0,
    paddingVertical: Platform.OS === 'ios' ? 10 : 8,
    paddingHorizontal: 0,
    margin: 0,
    borderWidth: 0,
    backgroundColor: 'transparent',
    color: colors.textPrimary,
    fontSize: 15,
  },
  searchInputDesk: {
    fontSize: 14,
    fontWeight: '500',
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink,
    height: 40,
    paddingVertical: 0,
  },
  searchInputDeskDense: {
    height: 44,
  },
  clearSearchBtn: {
    padding: 2,
  },
  sectionDivider: {
    alignSelf: 'stretch',
    height: StyleSheet.hairlineWidth,
    backgroundColor: colors.borderSoft,
    opacity: 0.9,
  },
  fieldLabel: {
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
  segmentedRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: colors.controlBorder,
    overflow: 'hidden',
    backgroundColor: colors.inputBackground,
  },
  segmentedRowTicket: {
    gap: 6,
    padding: 4,
    borderRadius: 10,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.tile,
    overflow: 'visible',
  },
  segmentedRowHug: {
    alignSelf: 'flex-start',
  },
  segment: {
    flex: 1,
    minWidth: 0,
    minHeight: 34,
    paddingHorizontal: 4,
    paddingVertical: 6,
    alignItems: 'center',
    justifyContent: 'center',
    borderRightWidth: StyleSheet.hairlineWidth,
    borderRightColor: colors.controlBorder,
  },
  segmentTicket: {
    minHeight: 42,
    borderRadius: 8,
    backgroundColor: 'transparent',
    borderRightWidth: 0,
  },
  segmentTicketDense: {
    minHeight: 34,
  },
  segmentHug: {
    flex: 0,
    flexGrow: 0,
    flexBasis: 'auto',
    paddingHorizontal: 16,
    minWidth: 88,
  },
  segmentLast: {
    borderRightWidth: 0,
  },
  segmentActive: {
    backgroundColor: ticketColors.brandSoft,
  },
  segmentText: {
    fontSize: 11,
    fontWeight: '700',
    color: colors.textSecondary,
    textAlign: 'center',
  },
  segmentTextActive: {
    color: ticketColors.gold,
  },
  segmentActiveTicket: {
    backgroundColor: ticketColors.brandSoft,
    borderWidth: 1,
    borderRightWidth: 1,
    borderColor: ticketColors.gold,
    borderRightColor: ticketColors.gold,
  },
  segmentTextActiveTicket: {
    color: ticketColors.brandInk,
    fontWeight: '700',
  },
  segmentActiveTicketSolid: {
    backgroundColor: ticketColors.brandPrimary,
    borderWidth: 1,
    borderRightWidth: 1,
    borderColor: ticketColors.brandPrimary,
    borderRightColor: ticketColors.brandPrimary,
  },
  segmentTextActiveTicketSolid: {
    color: ticketColors.goldInk,
    fontWeight: '800',
  },
  segmentTextTicket: {
    fontSize: 13,
    fontWeight: '600',
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink2,
  },
  chipsWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.xs,
  },
  chipsWrapHug: {
    alignSelf: 'flex-start',
  },
  chip: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: colors.borderSoft,
    backgroundColor: colors.inputBackground,
  },
  chipActive: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.gold,
  },
  /** Idle chip on ticket surfaces — surface + control border (proto .chips span). */
  chipTicket: {
    borderRadius: 999,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    paddingHorizontal: 13,
    paddingVertical: 8,
    justifyContent: 'center',
  },
  chipActiveTicket: {
    backgroundColor: ticketColors.brandSoft,
    borderColor: ticketColors.brandBorderSoft,
  },
  chipDisabled: {
    opacity: 0.55,
  },
  chipText: {
    fontSize: 13,
    fontWeight: '600',
    color: colors.textSecondary,
  },
  chipTextActive: {
    color: '#FFFFFF',
    fontWeight: '700',
  },
  chipTextTicket: {
    fontSize: 12.5,
    fontWeight: '600',
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink2,
  },
  chipTextActiveTicket: {
    color: ticketColors.brandInk,
  },
  pickerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    minHeight: 44,
    paddingHorizontal: 14,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: colors.controlBorder,
    backgroundColor: colors.inputBackground,
  },
  pickerRowActive: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.paper,
  },
  pickerStackRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    minHeight: 48,
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.tile,
  },
  /** Active stack picker — soft-teal wash (mismo idioma que KPI selected). */
  pickerStackRowActive: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
  },
  pickerStackMeta: {
    flex: 1,
    minWidth: 0,
    gap: 3,
  },
  pickerStackLabel: {
    fontSize: 11,
    fontWeight: '600',
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
  },
  pickerStackValue: {
    fontSize: 14,
    fontWeight: '600',
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink,
  },
  pickerStackValueMuted: {
    fontWeight: '500',
    color: ticketColors.ink2,
  },
  pickerChev: {
    fontSize: 12,
    fontWeight: '500',
    color: ticketColors.ink3,
    lineHeight: 16,
  },
  pickerChevIcon: {
    marginLeft: 2,
  },
  availabilityRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    minHeight: 48,
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.tile,
  },
  availabilityRowOn: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
  },
  availabilityCopy: {
    flex: 1,
    minWidth: 0,
    gap: 3,
  },
  availabilityTitle: {
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  availabilityHint: {
    fontSize: 12,
    fontWeight: '500',
    color: ticketColors.ink2,
    lineHeight: 16,
    fontFamily: ticketFonts.sans,
  },
  availabilitySwitch: {
    width: 40,
    height: 24,
    borderRadius: 99,
    backgroundColor: 'rgba(28,25,23,0.12)',
    padding: 3,
    justifyContent: 'center',
  },
  availabilitySwitchOn: {
    backgroundColor: ticketColors.gold,
  },
  availabilitySwitchKnob: {
    width: 18,
    height: 18,
    borderRadius: 99,
    backgroundColor: '#FFFFFF',
  },
  availabilitySwitchKnobOn: {
    alignSelf: 'flex-end',
    backgroundColor: colors.background,
  },
  masterCompactPicker: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.sm,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: colors.controlBorder,
    backgroundColor: colors.inputBackground,
    alignSelf: 'stretch',
  },
  masterCompactPickerDense: {
    paddingVertical: 7,
    borderRadius: 10,
  },
  /** Móvil: pickers en 2 columnas (Informes, maestros angostos). */
  mobilePickerGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.xs,
    alignSelf: 'stretch',
  },
  mobilePickerGridItem: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '48%',
    minWidth: 0,
    maxWidth: '100%',
  },
  masterCompactPickerActive: {
    borderColor: ticketColors.brandBorder,
    backgroundColor: ticketColors.brandSoft,
  },
  masterCompactPickerInner: {
    flex: 1,
    minWidth: 0,
    gap: 1,
  },
  masterCompactPickerCaption: {
    ...typography.caption,
    fontSize: 10,
    fontWeight: '700',
    color: colors.textMuted,
    textTransform: 'uppercase',
    letterSpacing: 0.35,
  },
  masterCompactPickerValue: {
    ...typography.body,
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '800',
    color: colors.textPrimary,
  },
  pickerLabel: {
    ...typography.caption,
    color: colors.textMuted,
    fontWeight: '700',
    flexShrink: 0,
  },
  pickerValue: {
    flex: 1,
    minWidth: 0,
    ...typography.body,
    color: colors.textPrimary,
    fontSize: 14,
    fontWeight: '700',
  },
  wideToolbarRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    gap: spacing.md,
    alignSelf: 'stretch',
  },
  wideToolbarGroup: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 200,
    minWidth: 0,
    gap: spacing.xs,
  },
  /** 768–960: pickers en fila sin forzar 200px mínimo por columna. */
  wideToolbarGroupNarrow: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '48%',
    minWidth: 140,
    maxWidth: '100%',
    gap: spacing.xs,
  },
  filterLanesRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    gap: spacing.md,
    alignSelf: 'stretch',
  },
  chipScrollContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    paddingVertical: 2,
  },
  chipScrollItem: {
    flexShrink: 0,
  },
  workspaceStack: {
    gap: spacing.sm,
    alignSelf: 'stretch',
  },
  workspaceSection: {
    gap: spacing.xs,
    alignSelf: 'stretch',
  },
  toolbarRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },
  toolbarSearchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
  },
  pageSizeSegmented: {
    flexDirection: 'row',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: colors.controlBorder,
    overflow: 'hidden',
    backgroundColor: colors.inputBackground,
  },
  pageSizeSegment: {
    minWidth: 40,
    minHeight: 32,
    paddingHorizontal: spacing.sm,
    alignItems: 'center',
    justifyContent: 'center',
    borderRightWidth: StyleSheet.hairlineWidth,
    borderRightColor: colors.controlBorder,
  },
  pageSizeSegmentLast: {
    borderRightWidth: 0,
  },
  /** Mismo look que `chip`, con layout horizontal para ícono opcional (POS «Solo con stock»). */
  toggleChipInner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    alignSelf: 'flex-start',
    maxWidth: '100%',
  },
  dismissChipInner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    alignSelf: 'flex-start',
    flexShrink: 0,
    maxWidth: 220,
    paddingRight: 10,
  },
  dismissChipLabel: {
    flexShrink: 1,
  },
  toggleChipDisabled: {
    opacity: 0.48,
  },
  toggleChipHint: {
    ...typography.caption,
    color: colors.textMuted,
    fontWeight: '600',
    flexShrink: 1,
  },
  collapseHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },
  collapseHeaderMain: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    minWidth: 0,
  },
  collapsedActiveFiltersChip: {
    borderRadius: 999,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.gold,
    paddingHorizontal: spacing.sm,
    paddingVertical: 3,
  },
  collapsedActiveFiltersChipText: {
    ...typography.caption,
    color: ticketColors.goldInk,
    fontWeight: '800',
    fontFamily: ticketFonts.sans,
  },
  moreFiltersBackdrop: {
    flex: 1,
    backgroundColor: colors.overlay,
    justifyContent: 'flex-end',
  },
  moreFiltersPanel: {
    borderTopLeftRadius: 18,
    borderTopRightRadius: 18,
    backgroundColor: colors.surface,
    padding: spacing.md,
    gap: spacing.sm,
  },
  moreFiltersTitle: {
    ...typography.body,
    color: colors.textPrimary,
    fontWeight: '800',
    marginBottom: spacing.xs,
  },
  moreFiltersDoneBtn: {
    alignSelf: 'stretch',
    marginTop: spacing.xs,
    minHeight: 44,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: colors.controlBorder,
    backgroundColor: colors.inputBackground,
    alignItems: 'center',
    justifyContent: 'center',
  },
  moreFiltersDoneText: {
    ...typography.body,
    color: colors.textPrimary,
    fontWeight: '700',
  },
});
